export default __webpack_public_path__ + "static/media/production-secondTab-howItWork.a0e5d3ca.png";